import { Button } from '@/components/ui/button';
import { INTERNAL_SAMPLE_CSV, PARTNER_SAMPLE_CSV } from '../constants';
import type { BulkUserType } from '../types';
import { downloadSampleCsv } from '../utils';

interface BulkImportInstructionsProps {
  userType: BulkUserType;
}

export function BulkImportInstructions({ userType }: BulkImportInstructionsProps) {
  const isInternal = userType === 'internal';

  return (
    <div className="space-y-3 rounded-md border border-gray-200 bg-gray-50 p-4">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <h3 className="text-sm font-semibold text-gray-900">Guia de preenchimento</h3>
          <p className="text-sm text-muted-foreground">
            O arquivo deve estar em UTF-8, com extensão .csv e separador ponto e vírgula (;).
          </p>
        </div>
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => downloadSampleCsv(userType)}
        >
          Baixar exemplo
        </Button>
      </div>
      <ul className="list-disc space-y-1 pl-5 text-sm text-gray-700">
        {isInternal ? (
          <>
            <li>Cabeçalhos obrigatórios: nome;email;role</li>
            <li>Roles aceitas: ADMIN_ROOT, ADMIN, AGENT, CURATOR, CREATIVE e VIEWER</li>
            <li>As marcas são selecionadas nesta tela e não devem estar no CSV</li>
            <li>O e-mail deve ser válido</li>
          </>
        ) : (
          <>
            <li>Cabeçalhos obrigatórios: nome;email;whatsapp</li>
            <li>As marcas são selecionadas nesta tela e não devem estar no CSV</li>
            <li>O e-mail deve ser válido</li>
            <li>O WhatsApp deve conter DDI, DDD e número</li>
            <li>O sistema armazenará somente os dígitos do WhatsApp</li>
          </>
        )}
      </ul>
      <pre className="overflow-x-auto rounded-md bg-white p-3 text-xs text-gray-800" aria-label="Exemplo de CSV">
        {isInternal ? INTERNAL_SAMPLE_CSV.trim() : PARTNER_SAMPLE_CSV.trim()}
      </pre>
    </div>
  );
}
